import { Stack } from '@src/common/components/Stack';
import { TextInput } from '@src/common/components/TextInput';
import { Typography } from '@src/common/components/Typography';
import { css } from '@src/common/styles/Styles';
import { theme } from '@src/common/styles/Theme';
import type { Order } from '@src/orders/domain/Order';
import type { PermitApplication } from '@src/orders/domain/PermitApplication';
import { Permit } from '@src/permits/Permit';
import { useTranslation } from 'react-i18next';

interface Props {
  permitApplication: PermitApplication;
  order: Order;
  permitConfirmationNumber: string;
  isMetric?: boolean;
}

export const PermitInformation = ({
  permitApplication,
  order,
  permitConfirmationNumber,
  isMetric = false,
}: Props) => {
  const { t } = useTranslation();

  return (
    <Stack gap={theme.spacing['6']} paddingX={theme.spacing['3']}>
      <Typography variant="h6" className={permitInfoSubtitle}>
        {t('permitConfirmationNumber')}
      </Typography>

      <TextInput
        size="small"
        value={permitConfirmationNumber}
        label={t('fields.permitConfirmationNumber')}
        readOnly={true}
        sx={{ width: '300px' }}
      />

      <Permit
        isMetric={isMetric}
        permitApplication={permitApplication}
        order={order}
      />
    </Stack>
  );
};

const permitInfoSubtitle = css(() => ({
  borderBottom: '1px solid',
}));
